import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <g clipPath="url(#clip0_3794_77597)">
      <mask height="24" id="mask0_3794_77597" maskUnits="userSpaceOnUse" width="36" x="0" y="0">
        <rect fill="#D9D9D9" height="24" rx="4" width="36" />
      </mask>
      <g mask="url(#mask0_3794_77597)">
        <rect fill="#FA3E2C" height="24" width="36" y="-6.10352e-05" />
        <path
          d="M15.4962 5.19051C15.4962 4.53301 16.0055 4 16.6338 4H20.1888C20.8171 4 21.3264 4.53301 21.3264 5.19051V5.66723H20.3513V5.19051C20.3513 5.09658 20.2785 5.02044 20.1888 5.02044L16.6338 5.02044C16.544 5.02044 16.4713 5.09658 16.4713 5.19051V5.66723H15.4962V5.19051Z"
          fill="white"
        />
        <path
          d="M11 8.08556V11.8699C11 12.796 11.7174 13.5468 12.6024 13.5468H13.9791V12.8576C13.9791 12.765 14.0508 12.6899 14.1393 12.6899H16.0249C16.1134 12.6899 16.1851 12.765 16.1851 12.8576V13.5468H20.8185V12.8576C20.8185 12.765 20.8903 12.6899 20.9788 12.6899H22.8644C22.9529 12.6899 23.0246 12.765 23.0246 12.8576V13.5468H24.3976C25.2826 13.5468 26 12.796 26 11.8699V8.08556C26 7.15943 25.2826 6.40866 24.3976 6.40866H12.6024C11.7174 6.40866 11 7.15943 11 8.08556Z"
          fill="white"
        />
        <path
          d="M26 13.7165C25.6 14.1037 25.065 14.3403 24.4771 14.3403H23.0246V15.5016C23.0246 15.5942 22.9529 15.6692 22.8644 15.6692H20.9788C20.8903 15.6692 20.8185 15.5942 20.8185 15.5016V14.3403H16.1851V15.5016C16.1851 15.5942 16.1134 15.6692 16.0249 15.6692H14.1393C14.0508 15.6692 13.9791 15.5942 13.9791 15.5016V14.3403H12.5231C11.9352 14.3403 11.4 14.1036 11 13.7162V17.3231C11 18.2492 11.7174 19 12.6024 19H24.3976C25.2826 19 26 18.2492 26 17.3231V13.7165Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3794_77597">
        <rect fill="white" height="24" rx="4" width="36" />
      </clipPath>
    </defs>
  </>,
  'PaymentCorporateWarning',
  {viewBox: '0 0 36 24'},
)
